var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mx-1",staticStyle:{"border-radius":"50%","background-color":"black","width":"5px","height":"5px","display":"block"}})
}
var staticRenderFns = []

export { render, staticRenderFns }